import type { CellContext } from '@tanstack/react-table';
import { ContentCell } from '../../components/content-cell';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

/** @deprecated This function is deprecated and will be removed in a future version. */
export function getColumnDefDateInMonth<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function DateInMonthCell(context: CellContext<T, unknown>) {
		const value = context.getValue();
		const row = context.row.original;
		const DEFAULT_RETURN_NULL = null;
		const DEFAULT_EMPTY_VALUE = '-';
		if (!value) return DEFAULT_EMPTY_VALUE;

		try {
			const dateObj = new Date(value as string | number | Date);

			if (isNaN(dateObj.getTime())) {
				return DEFAULT_EMPTY_VALUE;
			}

			// Format the date and time
			const dateFormatter = new Intl.DateTimeFormat(undefined, {
				month: 'short',
				day: '2-digit',
				year: 'numeric',
			});

			const formattedDate = dateFormatter.format(dateObj);

			// Use custom format if provided
			if (options?.parse) {
				const parsed = options.parse(value, row, options);

				return (
					<ContentCell
						primaryContent={parsed.primaryContent || formattedDate}
						moreContent={parsed.moreContent}
						moreContentHover={parsed.moreContentHover}
						moreContentLink={parsed.moreContentLink}
						icon={parsed.icon}
						iconOptions={parsed.iconOptions}
					/>
				);
			}

			return <ContentCell primaryContent={formattedDate} />;
		} catch (error) {
			console.error('Error formatting dateinmonth:', error);
			return DEFAULT_RETURN_NULL;
		}
	};
}
